import { addTargetSystem } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useAddTargetSystem = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (TargetSystemTypeNewData) => addTargetSystem(TargetSystemTypeNewData),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["GetTargetSystem"]);
        toast.fire(
          "Success",
          "Policy Management System Added Successfully",
          "success"
        );
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Policy Management System", "error");
      },
    }
  );

  return mutate;
};
export default useAddTargetSystem;
